import Vue from "vue";
import { getPaginated } from "@/utils/api-utils";
import { getField, updateField } from "vuex-map-fields";

export default {
  namespaced: true,
  state: {
    items: [],
    active_copy_to: {},
    communication_types_selected: [],
    communication_types: {},
    report_layouts: {},
    user_communication_types: {},
    user_report_layouts: {},
    first_name: "",
    last_name: "",
    copy_to_communication_types_selected: [],
    copy_to_report_layouts_selected: [],
    errors: []
  },
  getters: {
    getField,
    getById(state) {
      /**
       * Return an item by ID
       * @param {int} id - The ID of the item you want returned
       * @param {string} idField (optional) - The field used when filtering by ID
       */
      return (id, idField = "id") =>
        state.items.find(item => item[idField] === id) || {};
    },
    items(state) {
      return state.items;
    }
  },
  mutations: {
    updateField,
    setItems(state, payload) {
      Vue.set(state, "items", payload);
    },
    setCommunicationTypes(state, payload) {
      Vue.set(state, "communication_types", payload);
    },
    setReportLayouts(state, payload) {
      Vue.set(state, "report_layouts", payload);
    },
    setUserCommunicationTypes(state, payload) {
      Vue.set(state, "user_communication_types", payload);
    },
    setUserReportLayouts(state, payload) {
      Vue.set(state, "user_report_layouts", payload);
    },
    setErrors(state, payload) {
      let errors = [];
      if (payload?.username?._isUnique) {
        errors.push(payload?.username?._isUnique);
      }
      if (payload?.email?._isUnique) {
        errors.push(payload?.email?._isUnique);
      }
      Vue.set(state, "errors", errors);
    },
    setItem(state, payload) {
      const item = state.items.find(item => item.uuid === payload.uuid);
      if (item) {
        Object.assign(item, payload);
      }
    },
    setActiveCopyTo(state, payload) {
      Vue.set(state, "active_copy_to", payload);
      // Set reporting preferences
      if (payload.communication_types) {
        // Update the communication types proxy field, compatible for checkboxes
        Vue.set(
          state,
          "communication_types_selected",
          state.active_copy_to.communication_types.map(item => item.id)
        );
      }
    }
  },
  actions: {
    getPaginated: getPaginated("copy-to"),
    invite({ rootGetters, dispatch, commit }, { email, username }) {
      const client = rootGetters["clients/selectedClient"];
      return Vue.axios
        .post(`/copy-to`, {
          email,
          username,
          clients: [{ id: client.id }]
        })
        .then(res => {
          const { data } = res;
          // Reload Copy Tos
          console.log(res);
          dispatch("getClientsCopyTos");

          return data.data.id || false;
        })
        .catch(e => {
          if (e.response && e.response.status == 422) {
            const { data } = e.response;
            if (data && data.success === false && data.data.errors) {
              commit("setErrors", data.data.errors);
            }
          }
          console.error(e);
          return false;
        });
    },
    getClientsCopyTos({ rootGetters, commit }) {
      const client = rootGetters["clients/selectedClient"];
      if (client.id) {
        return Vue.axios
          .get(`/clients_copy_to`, {
            params: {
              client_id: client.id
            }
          })
          .then(res => {
            commit("setItems", res.data.data);
            const { data } = res;
            return data.success || false;
          })
          .catch(e => {
            console.error(e);
            return false;
          });
      }
    },
    getCopyTos({ commit }, params = {}) {
      return Vue.axios
        .get("/copy-to", {
          params: Object.keys(params).length ? params : undefined
        })
        .then(({ data }) => {
          commit("setItems", data.data);
          return data.success || false;
        })
        .catch(e => {
          console.error(e);
          return false;
        });
    },
    getCopyToReportPreferences({ commit }) {
      return Vue.axios
        .get("/copy-to/getReportingPreferences")
        .then(({ data }) => {
          commit("setCommunicationTypes", data.communication_types);
          commit("setReportLayouts", data.report_layouts);
          return data.success || false;
        });
    },
    getCopyToReportPreferencesForUser({ commit }, copyToId) {
      return Vue.axios
        .get(`/copy-to/getReportingPreferences?copy_to_id=${copyToId}`)
        .then(({ data }) => {
          commit("setCommunicationTypes", data.communication_types);
          commit("setReportLayouts", data.report_layouts);
          return data.success || false;
        });
    },
    editCopyTo({ commit }, payload) {
      return Vue.axios
        .put(`/copy-to/${payload.uuid}`, payload)
        .then(({ data }) => {
          commit("setItem", payload);
          return data.success || false;
        });
    },
    updateCopyToReportingPreferences(
      _,
      { copy_to_id, communication_types, report_layouts, first_name, last_name }
    ) {
      return Vue.axios
        .post("/copy-to/updateReportingPreferences/", {
          copy_to_id,
          communication_types,
          report_layouts,
          first_name,
          last_name
        })
        .then(({ data }) => {
          return data.success || false;
        });
    },
    getActiveCopyTo({ commit }, payload) {
      return Vue.axios
        .get(`/copy-to/` + payload.uuid, payload)
        .then(({ data }) => {
          commit("setActiveCopyTo", data.data);
          return data.success || false;
        });
    },
    editActiveCopyTo({ state }) {
      Vue.set(
        state.active_copy_to,
        "communication_types",
        state.communication_types_selected.map(id => {
          return { id };
        })
      );
      return Vue.axios
        .put(`/copy-to/` + state.active_copy_to.uuid, state.active_copy_to)
        .then(({ data }) => {
          return data.success || false;
        });
    }
  }
};
